<template>
  <div class="background" >
    <div id="content"  @scroll="handleScroll"> 
      
     <div id="lang"> 
      <a href="#" @click.prevent="navigateTo('usageTermsEn')">English</a>
      <a> | </a>
     <a href="#" @click.prevent="navigateTo('usageTermsCn')">中文</a>

     </div>
      
     <h1>Terms of Service</h1>
     <h2 >Contents of these terms</h2>
     <li>1. Terms statement and revision</li>
     <li>2. The service content we provide</li>
     <li>3. Use rules that users need to follow</li>
     <li>4. User privacy</li>
     
     <h2 >1. Statement and revision of terms</h2>
     <li>The current revision time of this clause is UTC+08:00 2020-12-20, and the previous revision time is UTC+08:00 2020-10-20.</li>
     <li>Recently revised content: user privacy.</li>
     <li>These terms are used to explain the service content of the mobile application 'yoyo vpn' (hereinafter referred to as this application)/rules to be followed by users/user privacy policy related content, that is, to clarify the rights and obligations of the service party and the serviced party. The right to interpret these terms Owner of the application.</li>
     
     <li>You must read these terms carefully before using this application. If you do not agree with the terms, you can report to the customer service staff of the application or stop using the application. When the user starts to use the application, we will consider that the user has agreed to all the terms. </li>
     <li>This app does not assume any responsibility for infringements caused by user behavior, including all criminal and civil liabilities. When a third party finds that users of this app are suspected of violating local laws, they can contact the operator of this app to cooperate with the verification process. </li>
     
     <li>These terms will be updated and improved from time to time. If the updated content conflicts with previous related content, please read the latest terms carefully and decide whether to continue using it.</li>
     
     
     <h2 >2. What we provide</h2>
     <li>The service provided by this application is a temporary digital network communication service. When the user's device is performing network communication, it encrypts and forwards the user's network communication data, and hides the user's direct access record to enhance the security of network communication and protect the user Privacy.</li>
     
     <li>This application must provide a secure and available network proxy server node, except for force majeure factors.</li>
     <li>This application is committed to providing users with satisfactory services. When users are not satisfied with certain services, they can submit feedback to the operation staff, or they can submit a refund application within 7 natural days of payment.</li>
     <li>When this app receives user feedback, it must resolve or respond to the user within the corresponding time limit.</li>
     
     <h2 >3. Use rules users should follow</h2>
     
     <li>When users use this application, they should abide by the laws of the region where they are used.</li>
     <li>Users shall not initiate behaviors that may cause infringement on other organizations or individuals through this application in any form.</li>
     <li>Users shall not publish and disseminate pornographic content (including but not limited to underage erotic content)/violent content/discriminatory content (including but not limited to religious discrimination/sex discrimination/regional discrimination/racial discrimination, etc.) in any form. Ethics related content.</li>
     
     <li>Users are not allowed to reverse-encode/crack/affect the normal operation of this application.</li>
     <li>When a user violates the above rules of use, the operator of this application has the right to directly deactivate his account without notifying the user. If the account involves payment, no refund will be given.</li>
     
     <h2 >4. User privacy</h2>
     
     <li>In the process of encrypting and forwarding network data, this application will not split/decrypt/cache user network data packets, only the network requests data packets for secondary encryption and forwarding.</li>
     <li>This application will not read or cache any user data unrelated to the functions of this application, and will not forward or cache any user data related to this application to any third party.</li>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'clearUserData'
    }
  },
  methods: {
      navigateTo(routeName) {
        this.$router.push({ name: routeName });
      },
  handleScroll(event) {
      const currentScrollTop = event.target.scrollTop;
      if (currentScrollTop > this.lastScrollTop && currentScrollTop > 0) {
        // 向下滚动
        // console.log('向下滚动');
      } else {
        // 向上滚动
        // console.log('向上滚动');
      }
      this.lastScrollTop = currentScrollTop;
    }
  }
}
</script>


<style scoped>
#content { 
  background-color: #eeeeee;
  float:none;
  margin: 20px 10%;
  padding-left:20px ;
  padding-right:20px ;
  padding-bottom:40px ;
  text-align:left;
  overflow-y: scroll;
  height: 80%; /* 根据需要设置高度 */
} 
#footer { 
  width: 100%;
  height:30px; 
  text-align:center;
  color:white;
  background: #333; 
} 
#lang {
  color:black;
  text-align:right;
  height:30;
  padding:5px;
  padding-top:10px ; 
} 

.background {
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url('../assets/weee.jpg');
  opacity: 0.8;
  background-size: cover;
  background-position: center;
  flex: 1;
}
h1 {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 8px;
  font-size: 20px;
  color: #4f4e4e;
}
h2 {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 8px;
  font-size: 16px;
  color: #4f4e4e;
}
li {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 8px;
  font-size: 13px;
  color: #4f4e4e;
}
</style>
